import { useState } from 'react';
import styled from 'styled-components';

import { Caret } from 'shared/icons/Caret';
import { SIZE_GENDER } from 'search/enums/constants';
import { SearchFiltersHoverAndSelectedStyle } from 'search/styles/SearchStyles';
import { useOutsideClick } from 'shared/hooks/useOutsideClick';
import { getTranslations } from 'shared/utils/getTranslations';

interface ISearchFilterSizeGenderSelectDesktop {
  options: Array<string>;
  handleSelectChange: (value: string) => void;
  selectedGender: string;
}

export const SearchFilterSizeGenderSelectDesktop = ({
  options,
  handleSelectChange,
  selectedGender,
}: ISearchFilterSizeGenderSelectDesktop) => {
  const [isOpen, setIsOpen] = useState(false);
  const sizeGender = getTranslations(SIZE_GENDER);

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  const ref = useOutsideClick(handleClickOutside);

  const toggleOpen = () => setIsOpen((prevState) => !prevState);

  const handleChange = (gender) => {
    handleSelectChange(gender);
    setIsOpen(false);
  };

  return (
    <SearchFilterSizeGenderSelectDesktop.Wrapper ref={ref}>
      <SearchFilterSizeGenderSelectDesktop.Select
        onClick={toggleOpen}
        data-qa="size_filter_gender_select"
      >
        <span data-qa="selected_gender">{sizeGender?.[selectedGender] || selectedGender}</span>
        <Caret direction={isOpen ? 'up' : 'down'} />
      </SearchFilterSizeGenderSelectDesktop.Select>
      {isOpen && (
        <SearchFilterSizeGenderSelectDesktop.Dropdown>
          {options.map((option) => (
            <SearchFilterSizeGenderSelectDesktop.Option
              key={option}
              onClick={() => handleChange(option)}
              data-qa={`${option}_gender_selection`}
            >
              {sizeGender?.[option] || option}
            </SearchFilterSizeGenderSelectDesktop.Option>
          ))}
        </SearchFilterSizeGenderSelectDesktop.Dropdown>
      )}
    </SearchFilterSizeGenderSelectDesktop.Wrapper>
  );
};

SearchFilterSizeGenderSelectDesktop.Wrapper = styled.div`
  margin-top: 10px;
  position: relative;
  min-width: 80px;
  max-width: 100px;
`;

SearchFilterSizeGenderSelectDesktop.Select = styled.button`
  border: 1px solid ${({ theme }) => theme.navigation.borderColor};
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 4px 4px;

  :focus,
  :active {
    border: 1px solid ${({ theme }) => theme.navigation.borderColor};
  }

  svg > path {
    stroke: ${({ theme }) => theme.navigation.borderColor} !important;
  }
`;

SearchFilterSizeGenderSelectDesktop.Dropdown = styled.div`
  position: absolute;
  text-transform: capitalize;
  background-color: ${({ theme }) => theme.navigation.backgroundColor};
  border: 1px solid ${({ theme }) => theme.navigation.borderColor};
  border-top: none;
  width: 100%;
  padding: 4px;
  top: 24px;
`;

SearchFilterSizeGenderSelectDesktop.Option = styled.div`
  cursor: pointer;
  padding: 4px 0;
  text-align: left;

  :hover {
    ${SearchFiltersHoverAndSelectedStyle}
  }
`;
